// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { memoriaSessione } from './memoriaSessione';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Se l'ambiente manca, createClient lancerebbe QUI, all'import del modulo:
// prima ancora che la guardia in main.tsx possa mostrare il suo messaggio.
// I segnaposto tengono vivo il modulo; a usarli davvero non ci arriva nessuno,
// perche' main.tsx blocca l'avvio quando la configurazione non c'e'.
const URL_SICURO = SUPABASE_URL || "http://configurazione-mancante.invalid";
const CHIAVE_SICURA = SUPABASE_PUBLISHABLE_KEY || "configurazione-mancante";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(URL_SICURO, CHIAVE_SICURA, {
  auth: {
    // Sul telefono la sessione vive nella memoria nativa (iOS puo' svuotare
    // il localStorage della vista web quando vuole: era il "mi butta fuori"
    // del 31/08); sul web resta il localStorage. Vedi memoriaSessione.ts.
    storage: memoriaSessione(),
    persistSession: true,
    autoRefreshToken: true,
  }
});